import AppStoreButton, {
  StoreEnum,
  ThemeEnum,
} from "@/components/app-store-button";
import { cn } from "@/lib/utils";

import { CloudIcon } from "./icons";
import App from "./images/app.png";
import QRImage from "./images/qr.png";

interface DownloadAppProps {
  className?: string;
  description?: string;
  title?: string;
}

export default function DownloadApp({
  className,
  description = "Discover the best escape rooms and haunted houses near you",
  title = "Download the Morty App",
}: DownloadAppProps) {
  return (
    <section className={cn("overflow-hidden", className)}>
      <div className="relative rounded-[20px] bg-gradient-to-t from-cerise to-amaranth pt-[372px] pb-[30px] md:pt-[285px] md:pb-0">
        <div className="absolute top-15 left-15 z-1 hidden h-75 w-[222px] md:block">
          <img
            alt="Scan to download the Morty app"
            className="absolute inset-0 h-full w-full object-contain"
            src={QRImage}
          />
        </div>
        <div className="absolute top-0 left-1/2 z-1 aspect-[389/787] w-3/4 max-w-[245px] -translate-x-1/2 -translate-y-[34%] md:top-1/2 md:right-0 md:left-auto md:w-[35%] md:max-w-[389px] md:translate-x-1/100 md:-translate-y-1/2">
          <img
            alt="Morty App"
            className="absolute inset-0 h-full w-full object-contain"
            src={App}
          />
        </div>
        <div className="z-1 w-full px-10 text-center md:absolute md:top-[105px] md:left-[322px] md:w-auto md:max-w-[350px] md:px-0 md:text-left">
          <h3 className="font-semibold text-32/[1.31em] md:pr-20 md:leading-[1.25em]">
            {title}
          </h3>
          <h4 className="mt-5 font-normal text-13/[1.85em] md:text-14/[1.71em]">
            {description}
          </h4>
          <div className="mt-5 flex flex-col items-center gap-4 md:flex-row">
            <AppStoreButton
              className="h-[46px] w-[154px] rounded-lg border border-black md:h-12 md:w-[161px] md:px-4"
              theme={ThemeEnum.LIGHT}
            />
            <AppStoreButton
              className="h-[46px] w-[154px] rounded-lg border border-black md:h-12 md:w-[161px] md:px-4"
              store={StoreEnum.GOOGLE}
              theme={ThemeEnum.LIGHT}
            />
          </div>
        </div>
        <div className="relative hidden h-34 rounded-b-[20px] bg-linear-269 from-10% from-royal-purple to-medium-orchid md:block">
          <CloudIcon className="absolute -top-[26px] right-[315px] h-[26px] w-[132px]" />
          <CloudIcon className="absolute bottom-0 left-[246px]" />
        </div>
      </div>
    </section>
  );
}
